import { Card } from '@components/primitives/Card.js'
import { APP_VERSION } from '@utils/constants.js'

export function SobreSection() {
  return (
    <Card surface='raised'>
      <div className='cf3-config-section'>
        <p className='cf3-config-section__title'>Sobre o app</p>
        <p className='cf3-config-section__desc'>
          Minha Obra versão {APP_VERSION} · seu guia e painel para acompanhar a construção.
        </p>
        <p className='cf3-config-storage-notice'>
          Seus dados ficam guardados <strong>somente neste aparelho</strong>. Se trocar de celular
          ou limpar os dados do app, exporte um backup antes na seção acima.
        </p>
      </div>
    </Card>
  )
}
